/* eslint-disable no-useless-catch */
import axios from 'axios';
export const baseURL = process.env.NODE_ENV === 'production'
    ? 'https://sistema.wfarm.com.br/api'
    : 'http://localhost:8081/api';

async function makeRequest(uri, method, data, options = {}) {
    let token = options.accessToken || localStorage.getItem('Authorization');

    if (localStorage.getItem('VetCustomer')) {
        const vetCustomer = JSON.parse(localStorage.getItem('VetCustomer'));
        const isCustomerApi = (vetCustomer.apis || []).some((route) => uri.startsWith(route));
        const isCustomerRoute = (vetCustomer.routes || []).some((route) => window.location.pathname.startsWith(route));
        if ((isCustomerApi && isCustomerRoute) || options.isVetCustomer) {
            token = vetCustomer.accessToken;
        }
    }

    const headers = {
        Authorization: `Bearer ${token}`,
        ...(options.headers || {}),
    };

    const client = axios.create({
        baseURL: baseURL,
        ...options,
        headers,
    });

    return client[method](uri, data)
        .then((response) => Promise.resolve(response))
        .catch(async (error) => {
            if (error?.response?.status === 401) {
                // localStorage.setItem('Authorization', '');
                // window.location.href = '/login';
                // return;
            }

            error.code = error.response && error.response.data && error.response.data.code;
            return Promise.reject(error);
        });
}

export const get = async (uri, options) => {
    try {
        const request = await makeRequest(uri, 'get', '', options);
        return request.data;
    } catch (err) {
        throw err;
    }
};

export const post = async (uri, data, options) => {
    try {
        const request = await makeRequest(uri, 'post', data, options);
        return request.data;
    } catch (err) {
        throw err;
    }
};

export const put = async (uri, data, options = {}) => {
    try {
        const request = await makeRequest(uri, 'put', data, options);
        return request.data;
    } catch (err) {
        throw err;
    }
};

export const patch = async (uri, data, options = {}) => {
    try {
        const request = await makeRequest(uri, 'patch', data, options);
        return request.data;
    } catch (err) {
        throw err;
    }
};

export const del = async (uri, options) => {
    try {
        const request = await makeRequest(uri, 'delete', '', options);
        return request.data;
    } catch (err) {
        throw err;
    }
};